module.exports = __webpack_public_path__ + "img/pslogo.85689634.png";